// extracted by mini-css-extract-plugin
export default {"contentBTN":"BtnVerMasConsultSt_contentBTN__4diAa","btnVer":"BtnVerMasConsultSt_btnVer__3Q05y","btnCon":"BtnVerMasConsultSt_btnCon__oHBS5"};